module.exports = __webpack_public_path__ + "img/chinesecompany57.e211b667.png";